// Shared formatting for the Account Expansion report.

// Whole-dollar currency, e.g. 12400 -> "$12,400".
export const formatCurrency = (value: number): string =>
  (value ?? 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

// Signed currency for deltas, e.g. 800 -> "+$800", -300 -> "-$300".
export const formatSignedCurrency = (value: number): string => {
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  return `${sign}${formatCurrency(Math.abs(value ?? 0))}`;
};

// e.g. 103.4 -> "103.4%".
export const formatPercent = (value: number): string =>
  `${(value ?? 0).toFixed(1)}%`;

// CSV field quoting.
export const escCsv = (val: string): string =>
  /[",\n]/.test(val) ? `"${val.replace(/"/g, '""')}"` : val;
